import { ChangeDetectionStrategy, Component, inject, NgZone, signal } from '@angular/core';
import gsap from "gsap";

@Component({
  selector: 'skyscraper1',
  standalone: false,
  templateUrl: './skyscraper1.component.html',
  styleUrl: './skyscraper1.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Skyscraper1Component {
  private zone = inject(NgZone);
  finalHeight = signal<number>(350); 
  height = signal<number>(200);


  ngAfterViewInit(): void {
    this.animate();
  }

  animate() {
    const obj = { x: this.height() };
    gsap.to(obj, {
      x: this.finalHeight(),
      duration: 1,
      delay: 0,
      ease: "power2.inOut",
      onUpdate: () => {
        this.zone.run(() => {
          this.height.set(obj.x);
        });
      },
    });
  }

}
